import classNames from 'classnames';
import { Form, useField, useFormikContext } from 'formik';
import { useEffect, useMemo } from 'react';
import { Button } from 'yoso';
import { useBalance } from '~/components/Balance/Balance.hooks';
import { breakpoints, useIsSmallerThan } from '~/components/Breakpoint/Breakpoint.hook';
import { BaseCard } from '~/components/Card';
import { useScoreUpCriteria } from '~/components/Challenge/Score/ChallengeScore.hooks';
import { ScoreUpCountField } from '~/components/Challenge/Score/Field/ScoreUpCountField';
import { ChallengeScoreUpValues } from '~/components/Challenge/Score/Form/ChallengeScoreUpForm.hooks';
import { ChallengeScoreUpFormHero } from '~/components/Challenge/Score/Form/Hero/ChallengeScoreUpFormHero';
import { T } from '~/components/I18n';
import { styles as bottomSheetStyles } from '~/components/Modal/BottomSheet/BottomSheet';
import { format } from '~/components/Util/number';
import styles from './ChallengeScoreUpForm.module.scss';

export type ChallengeScoreUpFormProps = {
  className?: string;
};
export const ChallengeScoreUpForm = ({ className }: ChallengeScoreUpFormProps) => {
  const {
    data: { amount: balance },
  } = useBalance();

  const {
    data: { baseScore },
  } = useScoreUpCriteria();

  const { setFieldValue, isValid, isSubmitting } = useFormikContext<ChallengeScoreUpValues>();
  const [{ value = 0 }] = useField({
    type: 'number',
    name: 'count',
  });

  const score = useMemo(() => baseScore * value, [baseScore, value]);

  useEffect(() => {
    setFieldValue('balance', balance);
  }, [setFieldValue, balance]);

  const isMobile = useIsSmallerThan(breakpoints.large);

  const disabled = !isValid || isSubmitting;

  return (
    <Form className={classNames(styles.root, className)}>
      <BaseCard className={styles.body} shadow>
        <ChallengeScoreUpFormHero />
        <hr className={styles.hr} />
        <ScoreUpCountField autoFocus={!isMobile} />
      </BaseCard>
      <div className={styles.footer}>
        <Button
          className={classNames(bottomSheetStyles.confirmButton, styles.button)}
          type="submit"
          color="secondary"
          disabled={disabled}
          block
          size="large"
          data-event="click"
          data-event-target="scoreup_btn">
          <T name="citizen_challenge_scoreup_popup_btn" options={[format(score)]} />
        </Button>
      </div>
    </Form>
  );
};
